module.exports = __webpack_public_path__ + "img/banner1.40a2da76.png";